import { Injectable } from '@angular/core';
import { PostmethodService } from '../../../app-config/postmethod.service';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NonSalesService {

  constructor(private ws: PostmethodService) { }
  nonsales(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "/lead/move-new-to-non-sales");
  }

  updateNonsales(request: any, id:any) {
    return this.ws.wsPut(request, environment.baseUrl + "/lead/updateNonsalesCategory",id);
  }
}
